import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-callback',
  template: ''
})
export class AuthCallbackComponent {}